import { SerializableObject } from './serializable-object';


/** The user email domain object. */
export class UserEmail extends SerializableObject {
  id: string;
  verified: boolean;
  email: string;
  userId: string;
  confirmationCode: string;
}
